import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import BioAdmin from 'types/ba/bioAdmin';

export const TagsServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.ltApiUrl + '/aem/bios/v1/tags',
	headers: {
		'apiKey': window.lt.api.biosApiKey,
	},
});

export default class TagsService extends ApiService implements BioAdmin.ITagsService {
	constructor() {
        super('bio-admin-tag-service', TagsServiceAxiosInstance);
    }

	public getTagGroupById(tagId: number): AxiosPromise<BioAdmin.ITagGroup[]> {
		return this.axiosInstance.get('groups/' + tagId);
	}

	public getTagGroups(): AxiosPromise<BioAdmin.ITagGroup[]> {
		return this.axiosInstance.get('groups');
	}

	public getTagGroupsAndData(): AxiosPromise<BioAdmin.ITagGroup[]> {
		return this.axiosInstance.get('groups/full');
	}
}
